import { connect } from 'react-redux';
import store from 'store';
import { updatePlotSampleRate } from 'js/store/actions/plotSampleRates';
import PlotSampleRateRadios from 'js/components/legacy/PlotSampleRateRadios';
import { show } from '../../store/actions/modal'; // Only premium or free_trial users should be able to toggle plot checkboxes

var isPremium = function isPremium(roles) {
  if (roles === undefined) {
    return false;
  }

  var premium = roles.indexOf('premium') > -1;
  var premiumTrial = roles.indexOf('premium_trial') > -1;
  return premium || premiumTrial;
};

var userRoles = store.get('userRoles');
var checkboxState = isPremium(userRoles) ? 'enabled' : 'disabled';
export default connect(function (state, ownProps) {
  return {
    plotSelectedSampleRate: state.plotSampleRates[ownProps.plotId],
    checkboxState: checkboxState
  };
}, function (dispatch, ownProps) {
  return {
    updateSelectedPlotSampleRate: function updateSelectedPlotSampleRate(sampleRate) {
      dispatch(updatePlotSampleRate(ownProps.plotId, sampleRate));
    },
    showPremiumModal: function showPremiumModal(props) {
      dispatch(show('PremiumModal', props));
    }
  };
})(PlotSampleRateRadios);